/**
 * Created by sange on 04/10/2017.
 */

export const appIcons = [
  'key',
  'premium',
  'category',
  'earth',
  'priority_high',
  'chat',
  'check',
  'category_producer'
]



// WEBPACK FOOTER //
// ./src/app/app.icons.ts